<template>
  <div style="border: 1px solid #333; padding: 1rem; margin-bottom: 1rem; margin: 1rem -1rem;">
    <p>
      <strong>A.</strong>
      {{ $t("contract.working_hours.option_a.paragraphs.first") }}
    </p>

    <div>
      <div v-if="options.A_fullTimeSelected">
        <span>{{ $t("contract.working_hours.option_a.full_time.label") }}</span>
      </div>
      <div v-if="options.A_otherSelected">
        <span>{{
          $t("contract.working_hours.option_a.other.label", {
            amount: options.A_amount,
          })
        }}</span>
      </div>
    </div>
    <div v-if="guideInAppendix">
      <p>
        <i>{{ $t("contract.working_hours.options.hours_in_appendix") }}</i>
      </p>
    </div>
    <div v-else>
      <p class="mt-2">
        {{ $t("contract.working_hours.option_a.paragraphs.second") }}
      </p>
      <p>
        <small>{{ $t("contract.working_hours.option_a.help") }}</small>
      </p>

      <table class="table">
        <tbody>
          <tr>
            <td>
              <p>{{ $t("contract.working_hours.days.monday") }}</p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.start") }}
                <span class="user-output">{{ days.monday.start }}</span>
              </p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.end") }}
                <span class="user-output">{{ days.monday.end }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>{{ $t("contract.working_hours.days.tuesday") }}</p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.start") }}
                <span class="user-output">{{ days.tuesday.start }}</span>
              </p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.end") }}
                <span class="user-output">{{ days.tuesday.end }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>{{ $t("contract.working_hours.days.wednesday") }}</p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.start") }}
                <span class="user-output">{{ days.wednesday.start }}</span>
              </p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.end") }}
                <span class="user-output">{{ days.wednesday.end }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>{{ $t("contract.working_hours.days.thursday") }}</p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.start") }}
                <span class="user-output">{{ days.thursday.start }}</span>
              </p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.end") }}
                <span class="user-output">{{ days.thursday.end }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>{{ $t("contract.working_hours.days.friday") }}</p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.start") }}
                <span class="user-output">{{ days.friday.start }}</span>
              </p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.end") }}
                <span class="user-output">{{ days.friday.end }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>{{ $t("contract.working_hours.days.saturday") }}</p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.start") }}
                <span class="user-output">{{ days.saturday.start }}</span>
              </p>
            </td>
            <td>
              <p>
                {{ $t("contract.working_hours.option_a.day.end") }}
                <span class="user-output">{{ days.saturday.end }}</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>{{ $t("contract.working_hours.option_a.paragraphs.third") }}</p>
    </div>
  </div>
</template>

<style scoped>
.table {
  width: 100%;
  table-layout: fixed;
}

.table tr {
  width: 33%;
}

.table tr p {
  margin-bottom: 0px;
}

.table td {
  padding: 0px;
}
</style>

<script>
export default {
  computed: {
    options() {
      return this.$store.state.contract.workingHours.options;
    },
    guideInAppendix() {
      return this.options.A_guideInAppendix;
    },
    days() {
      return this.$store.state.contract.workingHours.A.days;
    },
  },
};
</script>
